module.exports = __webpack_public_path__ + "img/chess_goblack.902776a9.png";